// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-index-js": function componentSrcPagesAboutIndexJs() {
    return import("./../../src/pages/about/index.js"
    /* webpackChunkName: "component---src-pages-about-index-js" */
    );
  },
  "component---src-pages-b-2-b-index-js": function componentSrcPagesB2BIndexJs() {
    return import("./../../src/pages/b2b/index.js"
    /* webpackChunkName: "component---src-pages-b-2-b-index-js" */
    );
  },
  "component---src-pages-b-2-b-thanks-js": function componentSrcPagesB2BThanksJs() {
    return import("./../../src/pages/b2b/thanks.js"
    /* webpackChunkName: "component---src-pages-b-2-b-thanks-js" */
    );
  },
  "component---src-pages-blog-index-js": function componentSrcPagesBlogIndexJs() {
    return import("./../../src/pages/blog/index.js"
    /* webpackChunkName: "component---src-pages-blog-index-js" */
    );
  },
  "component---src-pages-contact-examples-js": function componentSrcPagesContactExamplesJs() {
    return import("./../../src/pages/contact/examples.js"
    /* webpackChunkName: "component---src-pages-contact-examples-js" */
    );
  },
  "component---src-pages-contact-file-upload-js": function componentSrcPagesContactFileUploadJs() {
    return import("./../../src/pages/contact/file-upload.js"
    /* webpackChunkName: "component---src-pages-contact-file-upload-js" */
    );
  },
  "component---src-pages-contact-index-js": function componentSrcPagesContactIndexJs() {
    return import("./../../src/pages/contact/index.js"
    /* webpackChunkName: "component---src-pages-contact-index-js" */
    );
  },
  "component---src-pages-contact-thanks-js": function componentSrcPagesContactThanksJs() {
    return import("./../../src/pages/contact/thanks.js"
    /* webpackChunkName: "component---src-pages-contact-thanks-js" */
    );
  },
  "component---src-pages-exploremore-circulardesign-index-js": function componentSrcPagesExploremoreCirculardesignIndexJs() {
    return import("./../../src/pages/exploremore/circulardesign/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-circulardesign-index-js" */
    );
  },
  "component---src-pages-exploremore-communication-index-js": function componentSrcPagesExploremoreCommunicationIndexJs() {
    return import("./../../src/pages/exploremore/communication/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-communication-index-js" */
    );
  },
  "component---src-pages-exploremore-designthinking-index-js": function componentSrcPagesExploremoreDesignthinkingIndexJs() {
    return import("./../../src/pages/exploremore/designthinking/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-designthinking-index-js" */
    );
  },
  "component---src-pages-exploremore-gamedesign-index-js": function componentSrcPagesExploremoreGamedesignIndexJs() {
    return import("./../../src/pages/exploremore/gamedesign/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-gamedesign-index-js" */
    );
  },
  "component---src-pages-exploremore-index-js": function componentSrcPagesExploremoreIndexJs() {
    return import("./../../src/pages/exploremore/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-index-js" */
    );
  },
  "component---src-pages-exploremore-industrial-index-js": function componentSrcPagesExploremoreIndustrialIndexJs() {
    return import("./../../src/pages/exploremore/industrial/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-industrial-index-js" */
    );
  },
  "component---src-pages-exploremore-productdesign-index-js": function componentSrcPagesExploremoreProductdesignIndexJs() {
    return import("./../../src/pages/exploremore/productdesign/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-productdesign-index-js" */
    );
  },
  "component---src-pages-exploremore-storytelling-index-js": function componentSrcPagesExploremoreStorytellingIndexJs() {
    return import("./../../src/pages/exploremore/storytelling/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-storytelling-index-js" */
    );
  },
  "component---src-pages-exploremore-webandapplication-index-js": function componentSrcPagesExploremoreWebandapplicationIndexJs() {
    return import("./../../src/pages/exploremore/webandapplication/index.js"
    /* webpackChunkName: "component---src-pages-exploremore-webandapplication-index-js" */
    );
  },
  "component---src-pages-faq-index-js": function componentSrcPagesFaqIndexJs() {
    return import("./../../src/pages/faq/index.js"
    /* webpackChunkName: "component---src-pages-faq-index-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-index-old-js": function componentSrcPagesIndexOldJs() {
    return import("./../../src/pages/index_old.js"
    /* webpackChunkName: "component---src-pages-index-old-js" */
    );
  },
  "component---src-pages-info-index-js": function componentSrcPagesInfoIndexJs() {
    return import("./../../src/pages/info/index.js"
    /* webpackChunkName: "component---src-pages-info-index-js" */
    );
  },
  "component---src-pages-media-index-js": function componentSrcPagesMediaIndexJs() {
    return import("./../../src/pages/media/index.js"
    /* webpackChunkName: "component---src-pages-media-index-js" */
    );
  },
  "component---src-pages-oops-index-js": function componentSrcPagesOopsIndexJs() {
    return import("./../../src/pages/oops/index.js"
    /* webpackChunkName: "component---src-pages-oops-index-js" */
    );
  },
  "component---src-pages-partner-index-js": function componentSrcPagesPartnerIndexJs() {
    return import("./../../src/pages/partner/index.js"
    /* webpackChunkName: "component---src-pages-partner-index-js" */
    );
  },
  "component---src-pages-payment-index-js": function componentSrcPagesPaymentIndexJs() {
    return import("./../../src/pages/payment/index.js"
    /* webpackChunkName: "component---src-pages-payment-index-js" */
    );
  },
  "component---src-pages-play-demo-index-js": function componentSrcPagesPlayDemoIndexJs() {
    return import("./../../src/pages/play-demo/index.js"
    /* webpackChunkName: "component---src-pages-play-demo-index-js" */
    );
  },
  "component---src-pages-privacy-index-js": function componentSrcPagesPrivacyIndexJs() {
    return import("./../../src/pages/privacy/index.js"
    /* webpackChunkName: "component---src-pages-privacy-index-js" */
    );
  },
  "component---src-pages-privacy-index-olc-js": function componentSrcPagesPrivacyIndexOlcJs() {
    return import("./../../src/pages/privacy/index-olc.js"
    /* webpackChunkName: "component---src-pages-privacy-index-olc-js" */
    );
  },
  "component---src-pages-product-a-index-js": function componentSrcPagesProductAIndexJs() {
    return import("./../../src/pages/product_a/index.js"
    /* webpackChunkName: "component---src-pages-product-a-index-js" */
    );
  },
  "component---src-pages-product-index-js": function componentSrcPagesProductIndexJs() {
    return import("./../../src/pages/product/index.js"
    /* webpackChunkName: "component---src-pages-product-index-js" */
    );
  },
  "component---src-pages-programmes-index-js": function componentSrcPagesProgrammesIndexJs() {
    return import("./../../src/pages/programmes/index.js"
    /* webpackChunkName: "component---src-pages-programmes-index-js" */
    );
  },
  "component---src-pages-report-index-js": function componentSrcPagesReportIndexJs() {
    return import("./../../src/pages/report/index.js"
    /* webpackChunkName: "component---src-pages-report-index-js" */
    );
  },
  "component---src-pages-schoolsolution-index-js": function componentSrcPagesSchoolsolutionIndexJs() {
    return import("./../../src/pages/schoolsolution/index.js"
    /* webpackChunkName: "component---src-pages-schoolsolution-index-js" */
    );
  },
  "component---src-pages-schoolsolution-thanks-js": function componentSrcPagesSchoolsolutionThanksJs() {
    return import("./../../src/pages/schoolsolution/thanks.js"
    /* webpackChunkName: "component---src-pages-schoolsolution-thanks-js" */
    );
  },
  "component---src-pages-skills-index-js": function componentSrcPagesSkillsIndexJs() {
    return import("./../../src/pages/skills/index.js"
    /* webpackChunkName: "component---src-pages-skills-index-js" */
    );
  },
  "component---src-pages-tags-index-js": function componentSrcPagesTagsIndexJs() {
    return import("./../../src/pages/tags/index.js"
    /* webpackChunkName: "component---src-pages-tags-index-js" */
    );
  },
  "component---src-pages-term-index-1-js": function componentSrcPagesTermIndex1Js() {
    return import("./../../src/pages/term/index1.js"
    /* webpackChunkName: "component---src-pages-term-index-1-js" */
    );
  },
  "component---src-pages-term-index-js": function componentSrcPagesTermIndexJs() {
    return import("./../../src/pages/term/index.js"
    /* webpackChunkName: "component---src-pages-term-index-js" */
    );
  },
  "component---src-pages-thankyou-index-js": function componentSrcPagesThankyouIndexJs() {
    return import("./../../src/pages/thankyou/index.js"
    /* webpackChunkName: "component---src-pages-thankyou-index-js" */
    );
  },
  "component---src-templates-blog-post-js": function componentSrcTemplatesBlogPostJs() {
    return import("./../../src/templates/blog-post.js"
    /* webpackChunkName: "component---src-templates-blog-post-js" */
    );
  },
  "component---src-templates-index-page-js": function componentSrcTemplatesIndexPageJs() {
    return import("./../../src/templates/index-page.js"
    /* webpackChunkName: "component---src-templates-index-page-js" */
    );
  },
  "component---src-templates-product-page-js": function componentSrcTemplatesProductPageJs() {
    return import("./../../src/templates/product-page.js"
    /* webpackChunkName: "component---src-templates-product-page-js" */
    );
  },
  "component---src-templates-tags-js": function componentSrcTemplatesTagsJs() {
    return import("./../../src/templates/tags.js"
    /* webpackChunkName: "component---src-templates-tags-js" */
    );
  }
};